<template>
  <section>
    <div v-show="$store.state.operate!='添加'&&$store.state.operate!='编辑'&&$store.state.operate!='详情'&&$store.state.operate!='复制'" class="page-list">
	<com-page-title  @callbackOperate="callbackOperate" ></com-page-title>
	  <!-- 搜索栏 -->
	<el-form :inline="true"  class="demo-form-inline">
		
		  <el-form-item  label="">
		    <el-date-picker
		         v-model="form.dateRange"
		         type="datetimerange" :editable="false"
				 value-format='yyyy-MM-dd HH:mm:ss'
		        prefix-icon="none"
		         start-placeholder="开始时间"
		              end-placeholder="结束时间"
		        range-separator=""
				  @change="callbackIndex(1)"
		         
		         >
		       </el-date-picker>
		  </el-form-item>
		   <el-form-item label="">
		  <el-button @click="callbackIndex(1)" type="primary">搜索</el-button>
		  </el-form-item>
		 <!-- <el-form-item label="">
		  <el-button @click="ssa" type="primary">搜索s</el-button>
		  </el-form-item> -->
		</el-form>
		
      <el-table
        :data="pageData"
        highlight-current-row
        style="width: 100%;"
		ref="multipleTable"
		:height="$store.state.height-328"
		@select-all="selectChange"
		@select="selectChange"
		@sort-change="sortChange">
	   <template slot="empty">
		  <el-empty description="暂时没有数据"></el-empty>
	  </template>
		 <!--  <template v-for="item in columnList">
			 <com-page-isshow :sortable="item.isOrders?'custom':false" v-if="item.props=='isShow'"></com-page-isshow>
			 <com-page-imgurl v-if="item.props=='imgurl'" column='imgurl' title='图片' ></com-page-imgurl>
			 <com-page-orders :sortable="item.isOrders?'custom':false" v-else-if="item.props=='orders'"></com-page-orders>
		<el-table-column :sortable="item.isOrders?'custom':false"  v-else :fixed="item.isFixed"   :width="columnList.length<=6?'':item.dataType=='nvarchar'?200:120" :prop='item.props' :label='item.name' >
				   <template  slot-scope="scope">
				             <div   v-if="item.isColor"
				              :class="`text-${scope.row[item.props]}`"
				             >{{scope.row[item.props+"Text"]}}</div>
							 <div v-else-if="item.isTranslate">{{scope.row[item.props+"Text"]}}</div>
							<div v-else-if="item.isBoolean">{{scope.row[item.props]?'是':'否'}}</div>
							<div v-else>{{scope.row[item.props]}}</div>
				           </template>
						   
			   </el-table-column>
		  </template> -->
		  <el-table-column type="selection"></el-table-column>
		  <com-page-index></com-page-index>
		  <el-table-column sortable="custom"  prop='browser' label='浏览器' ></el-table-column>
		  <el-table-column prop='loginIp' label='ip' ></el-table-column>
		  		
		  <el-table-column prop='ipAddress' label='地址' ></el-table-column>
		   <el-table-column prop='loginType' label='应用' ></el-table-column>
		    <el-table-column prop='platform' label='类型' ></el-table-column>
		    <el-table-column sortable="custom"  prop='createTime' label='创建时间' ></el-table-column>
		  <el-table-column prop='osInfo' label='来源' ></el-table-column>
      </el-table>
	   <com-page-number @callbackOperate="callbackOperate" @callbackIndex="callbackIndex" ></com-page-number>
    </div>
	<!-- 表单页面 -->
    <div v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"> 
      <edit  @callbackPage="callbackPage"   :id="id"></edit>
    </div>
	<!-- 返回按钮 -->
	<com-page-return @callbackPage="callbackPage" v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"></com-page-return>
	<!-- 导入页面 -->
	<com-page-import @callbackImport="callbackImport"  v-if="$store.state.operate=='导入'"></com-page-import>
	<!-- 导出页面 -->
	<com-page-export  v-if="$store.state.operate=='导出'"></com-page-export>
 <!-- 账号配置列 -->
	<com-page-columns  @callbackColumns="callbackColumns"  v-if="$store.state.operate=='配置列'"></com-page-columns>
 </section>
</template>

<script>
import edit from "@/components/edit/com-edit-productSpu"; 
export default {
   components: {edit },
  data() {
    return {
	columnList:[],
		pageData:[],//页面数据
		id:'',//表单主键id
		form:{//搜索表单
			dateRange: this.$dateRangeCurrent,
		},
    };
  },
 
  methods: {
	  ssa(){
		   this.$store.commit("saveOperate", "编辑");
	  },
	  selectChange(selection,row){
	  this.$store.commit("saveSelect", selection);
	  },
   callbackImport(){
		   this.callbackIndex(1)
	  },
	  sortChange(column){
	var list= this.$store.state.list;
	list.pageOrder=column.order == 'descending'?'desc':'asc';
	list.pageSort=column.prop;
	this.$store.commit("saveList", list);
	 this.callbackIndex(1)
	},
	  callbackOperate(e){
		  if(e.operate=='添加'){
			  this.id="";
		  }
		   if(e.operate=='复制'||e.operate=='编辑'||e.operate=='详情'){
			  this.id=(e.data.id||'').toString();
		  }
		if(e.operate=='删除'){
			var id=this.$store.state.select.map(item=>item.id).join(',');
				this.$axios.post(`/api/LoginLog/PostLoginLogDeleteWhere` , JSON.stringify(id.toString())).then(e => {
					 this.$message.success('删除成功到同步服务器');
							this.callbackIndex();
				  }); 
		}
	  },
	  callbackPage(e){//表单返回事件
		  if(e.statusText=='添加'||e.statusText=='编辑'){
		    this.$store.commit("saveOperate", "");
			   this.$message.success('提交成功同步到服务器');
			this.callbackIndex();
		  }
	  },
    callbackIndex(i) {//获取分页数据
       var data=this.$pageParams(this.form,i)
      this.$axios.get(`/api/LoginLog/GetLoginLogPage`,data).then(e => {
		 this.$store.commit("saveList", e);
			this.pageData=e.pageData;
        });
    },callbackColumns(){
		// this.$axios.get('/api/Columns/GetColumnsRoleQuery',{params:{roleId:this.$store.state.user.roleId,tableName:this.$route.fullPath.substring(1,this.$route.fullPath.length)}}).then(e => {
		// 		if(e.length==0){
		// 						  this.$message.warning(this.$store.state.menu.name+'没有配置列表信息');
		// 					}
		// 					e.map(item=>item.name=item.name.replace('*'+"翻译", "").replace('*'+"必填", ""));
		// 					this.columnList=e;
		//   });
	}
  },
  mounted() {//页面加载事件
     this.$store.commit("saveList", {});
   this.callbackIndex(1)  
   this.callbackColumns()  
  }
  
};
</script>
<style>
</style>

